import useStore from "hooks/useStore";
import { LoginFormDTO } from "utils/helpers/models/auth/login";
import { useNavigate } from "react-router-dom";
import { Auth_APIS } from "libs/apis/auth.api";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import { successToaster } from "utils/helpers/common/alert-service";
import { PictureDTO } from "utils/helpers/models/common/picture.dto";

const useAuth = () => {
  const { setToken } = useStore();
  const navigate = useNavigate();

  const login = async (body: LoginFormDTO) => {
    const response = await Auth_APIS.login(body);
    const { status = false, message = "" } = response || {};

    if (status) {
      const token = response.data.jwtToken;
      setToken(token);
      localStorage.setItem("userData", JSON.stringify(response?.data?.user));
      successToaster(message);
      navigate(siteRoutes.home);
    }
  };

  const uploadFile = async (file: File): Promise<PictureDTO | null> => {
    const body = new FormData();
    body.append("file", file);
    const response = await Auth_APIS.uploadFile(body);
    const { status = false, data } = response || {};
    if (status) {
      return new PictureDTO(data);
    } else {
      return null;
    }
  };
  return {
    login,
    uploadFile,
  };
};

export default useAuth;
